import { Navigate, Outlet, useLocation } from "react-router-dom";
import jwt from "jwt-decode";
import { useEffect, useState } from "react";

export default function RedirectRouteLogin({ redirect1 = "/dashboard" }) {
  const [isValid, setIsValid] = useState(false);
  const [checked, setChecked] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");

    if (tokenParam) {
      localStorage.setItem("@medusapayments:access_token", tokenParam);

      try {
        const decoded = jwt(tokenParam);
        localStorage.setItem("@medusapayments:name", decoded.emp_razaosocial);

        const valid = decoded.exp && decoded.iat && decoded.emp_id;
        setIsValid(Boolean(valid));
      } catch (err) {
        console.error("Erro ao decodificar tokenParam:", err);
      }
    } else {
      const token = localStorage.getItem("@medusapayments:access_token");

      if (token) {
        try {
          const decoded = jwt(token);
          localStorage.setItem("@medusapayments:name", decoded.emp_razaosocial);

          const valid = decoded.exp && decoded.iat && decoded.emp_id;
          setIsValid(Boolean(valid));
        } catch (err) {
          console.error("Erro ao decodificar token do localStorage:", err);
        }
      } else {
        // Nenhum token presente, não faz nada
        setChecked(true);
        return;
      }
    }

    setChecked(true);
  }, [location]);

  if (!checked) return null;

  if (isValid) {
    return <Navigate to={redirect1} replace />;
  }

  return <Outlet />;
}
